export interface IUpdateServicesDataRequest {
    id: number,
    isFamilyVoucherParticipant: boolean,
    hasVoucherRestrictions: number,
    performsIncompatibleTransplants: number,
    performsDesensitization: number,
    performsNonSteroidProtocol: number,
    maxPairWorkups: number,
    minimumNddAge: number,
    maximumNddAge: number,
    providesDonorInsurance: number,
    donorWorkupWait: number,
    recipientWorkupWait: number,
    maxBulkCheekSwabsWithin24Hours: number
    hasAbPatients: number,
    canUtilizeA2toBPatients: number,
    livingDonorFullfillJobAsDonorNav: number
}